import React, { useState } from 'react';
import PropTypes from 'prop-types';
import filterStyles from 'components/calendar/EventFilter.module.css';
import styles from 'styles/modules/Archives.module.css';
import merchantFilterStyles from './MerchantsArchiveFilter.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

const MerchantsArchiveFilter = ({
  selectedTypes,
  handleTypeToggle,
  searchQuery,
  handleSearchChange,
  resetFilters,
  availableTypes,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className={filterStyles.filterWrap}>
      <div className={filterStyles.filterContainer}>
        <p className={filterStyles.label}>Filtrer le contenu :</p>
        <div className={filterStyles.filters}>

          {/* Champ de recherche */}
          <label htmlFor="searchInput" className="sr-only">
            Rechercher :
          </label>
          <input
            type="text"
            id="searchInput"
            placeholder="Rechercher un commerce..."
            value={searchQuery}
            onChange={handleSearchChange}
            className={filterStyles.nameFilter}
          />

          {/* Dropdown multi-select pour les types */}
          <div className={`${filterStyles.dropdown} ${merchantFilterStyles.multiSelectDropdown}`}>
            <label htmlFor="typeFilter" className="sr-only">
              Types de commerce
            </label>
            <button
              type="button"
              className={filterStyles.categoryFilter}
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              {selectedTypes.length === 0
                ? 'Tous les types'
                : selectedTypes.length === 1
                ? availableTypes.find(t => t.slug === selectedTypes[0])?.name
                : `${selectedTypes.length} types sélectionnés`}
            </button>
            <FontAwesomeIcon icon={faCaretDown} />
            
            {isDropdownOpen && (
              <div className={merchantFilterStyles.dropdownMenu}>
                {availableTypes.map(type => (
                  <label key={type.id} className={merchantFilterStyles.checkboxLabel}>
                    <input
                      type="checkbox"
                      checked={selectedTypes.includes(type.slug)}
                      onChange={() => handleTypeToggle(type.slug)}
                      className={merchantFilterStyles.checkbox}
                    />
                    <span>{type.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Bouton pour réinitialiser */}
      <div className={styles.filters}>
        <div className={filterStyles.filterContainer}>
          <button
            className={`arrow-link ${styles.resetTags}`}
            onClick={resetFilters}
          >
            Réinitialiser les filtres
          </button>
        </div>
      </div>
    </div>
  );
};

MerchantsArchiveFilter.propTypes = {
  selectedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleTypeToggle: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  availableTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default MerchantsArchiveFilter;






